export const SIGNUP = "/user/sign-up";
export const POST_LOGIN = "/auth/login";
export const GOOGLE_LOGIN = "/auth/google-login";
export const FORGOT_PASSWORD = "/auth/forgot-password";
export const OTP = "/auth/verify-otp";
export const RESET_PASSWORD = "/auth/reset-password";
export const CHANGE_PASSWORD = "/auth/change-password";
export const UPDATE_PROFILE = "/user/update-profile";
export const USER_DETAIL = (userId) => `/user/${userId}`;
export const UNSUBSCRIBE_SUBSCRIPTION = "/user/subscription/unsubscribe";
export const UPLOAD_FILE = "/uploads/file";
export const UPLOAD_FILES = "/uploads/files";
export const BOOKS = "/books";
export const BLOGS = "/blogs";
export const SAVES = "/saves";
export const SAVE_DETAIL = (bookId) => `/saves/${bookId}`;
export const READINGS = "/readings";
export const READING_DETAIL = (bookId) => `/readings/${bookId}`;
export const EVENTS = "/events";
export const SUBSCRIPTION_PLANS = "/subscription";
export const CONTACT = "/contact";
export const PRIVACY_POLICY = "/privacyPolicy";
export const REFUND_POLICY = "/refundPolicy";
export const TERMS_AND_CONDITIONS = "/termAndCondition";
export const SHIPPING_INFO = "/shippingInfo";
export const ORDERS = "/orders";
export const RAPID_GATEWAY_CHECKOUT = "/payments/rapid-gateway/checkout";
export const PAYMENT_DETAIL = (paymentId) => `/payments/${paymentId}`;
export const RAPID_GATEWAY_RETURN = (paymentId) =>
  `/payments/rapid-gateway/return/${paymentId}`;
export const RAPID_GATEWAY_LOCAL_WEBHOOK = (paymentId) =>
  `/payments/rapid-gateway/local-webhook/${paymentId}`;
export const SUBSCRIBE_ANNOUNCEMENT_TOPIC = "/notifications/topic/announcement/subscribe";
export const UNSUBSCRIBE_ANNOUNCEMENT_TOPIC = "/notifications/topic/announcement/unsubscribe";
